import React from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { patchStartDelivery } from '../../../../actions';
import { YANDEX_BUSINESS_NUMBER } from '../../../../config/constants';
import YangoDeliveryButton from './yango/YangoDeliveryButton';

const DeliveryStartButton = ({
  deliveryId,
  dispatchPatchStartDelivery,
  businessTaxId,
}) => {
  const startDelivery = () => {
    dispatchPatchStartDelivery({ deliveryId });
  };

  const renderButton = () => {
    if (businessTaxId === YANDEX_BUSINESS_NUMBER) {
      return <YangoDeliveryButton deliveryId={deliveryId} />;
    }

    return (
      <Button color="success" onClick={startDelivery}>
        <i className="fa fa-motorcycle" /> Empezar reparto
      </Button>
    );
  };

  return <>{renderButton()}</>;
};

DeliveryStartButton.propTypes = {
  dispatchPatchStartDelivery: PropTypes.func.isRequired,
  deliveryId: PropTypes.number.isRequired,
  businessTaxId: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
  dispatchPatchStartDelivery: patchStartDelivery,
};

export default connect(null, mapDispatchToProps)(DeliveryStartButton);
